import React, { Component } from 'react';
import Dico from '../../helpers/Dico'
import ServiceCriteria from './ServiceCriteria';
import CustomerCriteria from './CustomerCriteria';
import DurationSelector from './DurationSelector';
import MileagesSelector from './MileagesSelector';
import DepositSelector from './DepositSelector';

class CalculatorCriteria extends Component {

    handleOfferChange = (event, productKey) => {
        this.props.onChangeProduct(productKey);
    };
    handleDepositChange = value => {
        value *= 1.0;
        this.props.onChangeDeposit(value, this.props.settings);
    }
    handleServiceChange = (svcMap) => {
        this.props.onChangeService(svcMap, this.props.settings);
    }
    handleCustomerChange = (customer) => {
        this.props.onChangeCustomer(customer, this.props.settings);
    }
    getMessage(i18nKey) { return Dico.getMessage(this.props.context.countryCode, this.props.context.languageCode, i18nKey) }

    render() {
        const parameters = this.props.parameters ? this.props.parameters : {};
        var hasCriteria = this.props.responseCriteria && !this.props.responseCriteria.hasError;
        var customerCriteria = this.props.responseCriteria ? this.props.responseCriteria.customerCriteria : null;
        var productKey = parameters.productKey != null ? parameters.productKey :
            this.props.responseOffers && this.props.responseOffers.selectedProductId && this.props.responseOffers.selectedProductId.productKey;
        return (
            <div className="row shadow rounded p-2">
                <h5>{this.getMessage('calculatorPage.criteria.title')}</h5>
                <div className="row shadow-sm rounded m-auto">
                    {this.props.responseOffers &&
                        this.props.responseOffers.hasOffers && this.props.responseOffers.selectedProductId != null &&
                        <React.Fragment>
                            <h5 className="text-secondary">{this.getMessage('calculatorPage.criteria.product')}</h5>
                            {this.props.responseOffers.offers.map((product, index) => (
                                <div className="form-check" key={index}>
                                    <input className="form-check-input" type="radio" name="flexRadioProducts" id={`flexRadioProducts${index}`}
                                        checked={product.financialProductId.productKey === productKey}
                                        onChange={event => { this.handleOfferChange(event, product.financialProductId.productKey) }}
                                    />
                                    <label className="form-check-label" htmlFor={`flexRadioProducts${index}`}>
                                        {product.label}
                                    </label>
                                </div>

                            ))}
                        </React.Fragment>
                    }
                </div>
                {hasCriteria && (this.props.responseCriteria.packages != null || this.props.responseCriteria.services != null) &&
                    <div className="row shadow-sm rounded m-auto">
                        <h5 className="text-secondary">{this.getMessage('calculatorPage.criteria.services')}</h5>
                        <ServiceCriteria
                            packagesData={this.props.responseCriteria.packages}
                            servicesData={this.props.responseCriteria.services}
                            svcMap={this.props.svcMap}
                            onChange={this.handleServiceChange}
                        />
                    </div>
                }
                {hasCriteria && customerCriteria != null &&
                    <div className="row shadow-sm rounded m-auto">
                        <h5 className="text-secondary">{this.getMessage('calculatorPage.criteria.customer')}</h5>
                        <CustomerCriteria
                            context={this.props.context}
                            availableValues={customerCriteria}
                            onChange={this.handleCustomerChange}
                        />
                    </div>
                }
                {hasCriteria && <DurationSelector
                    settings={this.props.settings}
                    context={this.props.context}
                    parameters={this.props.parameters}
                    contextCriteria={this.props.contextCriteria}
                    onChange={this.props.onChangeDuration}
                />}
                {hasCriteria && <MileagesSelector
                    settings={this.props.settings}
                    context={this.props.context}
                    mileages={this.props.responseCriteria.mileages}
                    parameters={this.props.parameters}
                    contextCriteria={this.props.contextCriteria}
                    onChange={this.props.onChangeMileage}
                />}
                {hasCriteria && <DepositSelector
                    settings={this.props.settings}
                    context={this.props.context}
                    deposits={this.props.responseCriteria.deposits}
                    parameters={this.props.parameters}
                    contextCriteria={this.props.contextCriteria}
                    onChange={this.props.onChangeDeposit}
                />}
            </div>
        );
    }
}

export default (CalculatorCriteria)
